<template>
  <el-container>
    <Menu :activeIndex='activeIndex'></Menu>
    <el-container>
      <el-header>
        <h2>学习圈管理</h2>
        <!--<el-button size="medium" plain type="success" id='btn_add' @click="dialogBannerVisible = true,clearform()">新增通告</el-button>-->
      </el-header>
      <el-main>
        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%;" :stripe="true" :border='true'>

          <el-table-column prop="id" label="ID" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="text_content" label="内容" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="first_img" label="首图" style="">
            <template slot-scope="scope">
              <img :src="scope.row.first_img" alt="" style="width: 100px;margin-top:5px;">
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="发表时间"></el-table-column>
          <el-table-column prop="enable" label="是否启用" :show-overflow-tooltip="true">
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-button type="primary" size="mini" plain
                           @click="handleEdit(scope.row.id)">置顶
                </el-button>
                <el-button size="mini" plain type="danger" @click="handleDelete(scope.row.id)">删除
                </el-button>
                <el-button size="mini" plain type="warning" @click="handleUserLevel(scope.row.id)">禁言此用户</el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :page-size="10"
          background
          layout="prev, pager, next"
          :total="totalCount" @current-change="handleCurrentChange" :current-page.sync="currentPage">
        </el-pagination>
      </el-main>
      <el-footer>Copyright &copy; Soren经济学人 技术支持 ：
        <a href="#">苏州西西弗斯商务信息咨询有限公司</a>
      </el-footer>
    </el-container>
    <el-dialog title="学习圈编辑" :visible.sync="dialogBannerVisible">

      <el-form :model="form">
        <el-form-item label="ID" :label-width="formLabelWidth">
          <el-input v-model="form.id" disabled></el-input>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input v-model="form.sort" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="内容" :label-width="formLabelWidth">
          <el-input v-model="form.content" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否启用" :label-width="formLabelWidth">
          <el-input v-model="form.enable" auto-complete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogBannerVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogBannerVisible = false,submitbanner(form)">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>

</template>

<script>
    export default {
        data() {
            return {
                activeIndex: "12",
                tableData: [],
                totalCount: 0,
                currentPage: 1,
                formLabelWidth: "150px",
                dialogBannerVisible: false,
                form: {
                    id: "",
                    sort: "",
                    content: "",
                    enable: ''
                }
            };
        },
        created() {
            this.getData(this.currentPage);
        },
        updated: function () {
            this.ifHavemark();
        },

        methods: {
            // 页面 表格数据 初始化
            getData(page) {
                var self = this;
                let currentPage = page
                self.axios.post("https://soren.guanqimiao.cn/Dynamic/getAllDynamic", {
                    mark: localStorage.getItem("mark"),
                    currentPage: currentPage
                })
                    .then(function (response) {
                        if (response.status == 200) {
                            self.tableData = response.data.data;
                            self.totalCount = response.data.total;
                        } else if (response.data.code == "400") {
                            self.$message({
                                type: "error",
                                message: "操作失败"
                            });
                        } else {
                            //self.ifLogin();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            handleCurrentChange(val) {
                var self = this;
                //console.log(`当前页: ${val}`);
                self.currentPage = val;
                self.getData(this.currentPage);
            },

            handleDelete(id) {
                //console.log(rows);
                //console.log(this.tableData);
                var self = this;
                self
                    .$confirm("确认删除(实际就是设为不启用状态)?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    })
                    .then(() => {
                        self.axios.post("https://soren.guanqimiao.cn/Dynamic/deleteDynamic", {
                            mark: localStorage.getItem("mark"),
                            dynamicId: id
                        })
                            .then(function (response) {
                                if (response.status == 200) {
                                    self.$message({
                                        message: "操作成功",
                                        type: "success"
                                    });
                                } else if (response.status == 400) {
                                    self.$message({
                                        type: "error",
                                        message: "操作失败"
                                    });
                                } else {
                                    self.ifLogin();
                                }

                                self.getData(this.currentPage);
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    })
                    .catch(() => {
                        self.$message({
                            type: "info",
                            message: "已取消删除"
                        });
                    });
            },
            handleEdit(id) {
                //置顶操作
                var self = this;
                self
                    .$confirm("确认置顶吗?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    })
                    .then(() => {
                        self.axios.post("https://soren.guanqimiao.cn/Dynamic/makeDynamicTop", {
                            mark: localStorage.getItem("mark"),
                            dynamicId: id
                        })
                            .then(function (response) {
                                if (response.status == 200) {
                                    self.$message({
                                        message: response.data,
                                        type: "success"
                                    });
                                } else if (response.status == 400) {
                                    self.$message({
                                        type: "error",
                                        message: response.data
                                    });
                                } else {
                                    self.ifLogin();
                                }

                                self.getData(this.currentPage);
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    })
                    .catch(() => {
                        self.$message({
                            type: "info",
                            message: "已取消删除"
                        });
                    });
            },
            handleUserLevel(id) {
                //置顶操作
                var self = this;
                self
                    .$confirm("确认禁言此用户吗?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    })
                    .then(() => {
                        self.axios.post("https://soren.guanqimiao.cn/Dynamic/changeUserLevel", {
                            mark: localStorage.getItem("mark"),
                            dynamicId: id
                        })
                            .then(function (response) {
                                if (response.status == 200) {
                                    self.$message({
                                        message: response.data,
                                        type: "success"
                                    });
                                } else if (response.status == 202) {
                                    self.$message({
                                        type: "error",
                                        message: response.data
                                    });
                                } else {
                                    self.ifLogin();
                                }
                                self.getData(this.currentPage);
                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    })
                    .catch(() => {
                        self.$message({
                            type: "info",
                            message: "已取消删除"
                        });
                    });
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .el-header {
    position: relative;
  }

  .el-header h2 {
    margin: 0;
    line-height: 60px;
  }

  .el-header #btn_add {
    position: absolute;
    right: 25px;
    top: 12px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #67c23a;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px !important;
    text-align: center;
  }

  .avatar {
    width: 100%;
    height: auto;
    display: block;
  }

  .Saveid {
    cursor: pointer;
    color: #67c23a;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dynamic.vue